import { render, staticRenderFns } from "./TaxRecharge.vue?vue&type=template&id=460e47f4&scoped=true&"
import script from "./TaxRecharge.vue?vue&type=script&lang=js&"
export * from "./TaxRecharge.vue?vue&type=script&lang=js&"
import style0 from "./TaxRecharge.vue?vue&type=style&index=0&id=460e47f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e47f4",
  null
  
)

export default component.exports